import React from 'react'

const TableRow = props =>
	<tr className="mpui-table-row" {...props} />

export default TableRow
